module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-Italic.b09350c7.woff2";